/**
 * @author       samuel@zumper.com (Samuel Shih)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  ModalFallback.jsx
 */

import { Dialog, DialogContent, DialogOverlay, DialogPortal, DialogTitle } from '@zcode-ui/shadz-ui'
import React, { useCallback, useState } from 'react'
import { ErrorFallback } from './ErrorFallback'

interface ModalFallbackProps {
  onClickReload?: React.MouseEventHandler<HTMLButtonElement>
  message: string
}

const ModalFallback = ({ onClickReload, message }: ModalFallbackProps) => {
  const [showFallback, setShowFallback] = useState(true)
  const onClickClose = useCallback(() => {
    setShowFallback(false)
  }, [])
  return (
    <Dialog
      open={showFallback}
      onOpenChange={(open) => {
        if (!open) {
          onClickClose()
        }
      }}
    >
      <DialogPortal>
        <DialogOverlay />
        <DialogContent className="z-modal">
          <DialogTitle className="sr-only">Error Fallback</DialogTitle>
          <ErrorFallback
            message={message}
            onClickClose={onClickClose}
            onClickReload={onClickReload}
          />
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}

export default ModalFallback
